import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';



const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
}));

export default function Signature(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const [link, setLink] = useState(props.props.link ? props.props.link : "");
  const [allcomplete, setAllcomplete] = useState(props.props.allcomplete ? props.props.allcomplete : false);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };


  const handleNext = props.props ? props.props.function: "";

  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const {link} = event.target.elements;
      if (allcomplete) {
        try {
       
          var user = firebase.auth().currentUser;
          const dateObj = new Date();
          const options = {year: 'numeric', month: 'long', day: 'numeric'};
          const date = dateObj.toLocaleDateString(undefined, options)
          const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  
          db.collection("users").doc(user.email).update({
            Signature: {
              link: link.value,
              completed: true
            },
            LastUpdated: (date + " " + time)
          });
  
          console.log(link.value);
          handleNext();
        } catch (error) {
          alert(error);
        }

      } else {
        setOpen(true);
        console.log("nothing");
      }
      
    },
    [history]
  );

   const onChangeFunction = (component, value) => {
        setLink(value);
    };

   const populateValues = () => {
        console.log("in here")
        const fs = firebase.firestore()
        var user = firebase.auth().currentUser;
        fs.collection("users").doc(user.email).get()
        .then((snapshot) => {
            if (snapshot.exists) { 
            const dat  = snapshot.data()
            setLink(dat.ApplicationFee.link ? dat.ApplicationFee.link : "")
            } else {
            console.log("No data available");
            }
        }).catch((error) => {
            console.log("error")
        })
   }

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
      <Typography component="h1" variant="h3">
            Signature
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
        By typing my full name below, I understand that upon submitting this application with registration deposit payment, my team cannot be refunded for this amount. In the case that my team is accepted and has declined participation in Bhangra in the Burgh XV, I understand that my team will not be refunded for this registration fee.

        </Typography>
        <Box pb={2}/>
        <form className={classes.form} onSubmit={handleSignUp}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="link"
            label="Full Name"
            name="link"
            value = {link}
            onChange = {onChangeFunction}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </div>
    </Container>
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
    <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
    <DialogContent>
          <DialogContentText >
            Please submit all other tasks first. Note if you are seeing this and you have already submitted everything, please wait 30 seconds and refresh.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Okay
          </Button>
        </DialogActions>
    </Dialog>

    </ThemeProvider>
  );
}